export enum UserStatus {
    PENDING_ACTIVATION = 1,
    ACTIVE = 2,
}